// extracted by mini-css-extract-plugin
export var hidden = "WineSelect-module--hidden--l8ayk";
export var nativeSelect = "WineSelect-module--nativeSelect--Yfgb3";
export var option = "WineSelect-module--option--0yggP";
export var select = "WineSelect-module--select--Irjv6";